/**
 * Shared Table column options for primary text identifiers (name, title, etc.).
 * - Starts wide enough for current-page values (`fitContent`)
 * - User can still drag narrower down to `minWidth`
 */
export function fitContentTextColumnOptions(overrides = {}) {
  return {
    fitContent: true,
    minWidth: 100,
    maxWidth: 480,
    flexGrow: 2,
    ellipsis: false,
    ...overrides,
  };
}

/**
 * Compact columns sized to header + cell content (badges, short numbers, etc.).
 */
export function fitContentCompactColumnOptions(overrides = {}) {
  return {
    fitContent: true,
    minWidth: 88,
    maxWidth: 160,
    shrink: false,
    ...overrides,
  };
}
